<template>
  <v-container  class=" ma-4">
    <p>
      <b>How it works: </b><br />On the site you can write a story and let other people on the web read
      it or add to it. After you add a page to the story, other people that have
      your story link can read the story and then add another page and continue
      your story.
    </p>

    <p>
      <b>How does the choose your own adventure work? </b><br />
      When you add a page you can either have the story just continue from there
      or you can come up with options the reader can choose. For example, you can
      add options like: 'Emma chooses the door on the right' and 'Emma chooses
      the door on the left'. The options will let the reader choose what happens
      next in the story as they read it. You (or other people) can write the pages the reader sees
      when they click on either option.
    </p>

    <p>
      <b>Are my stories private?</b><br />
      When you create a story two links are created for your story.
      A "read only" link and an "add-able link". Anyone
      with the read-only link can read your story. Anyone with the "add-able" can add to your story. So only share that
      Only share the add-able link with people you trust to add new pages into your story.
      <br /> <br />
      So, the story is private within the group who have the links.
    </p>

    <p>
      <b>Is it free?</b><br />
      Yes! I wrote it because I thought it would be fun for my daughter.
      If the hosting gets too expensive I'll ask for donations, but the site will
      stay free.
    </p>

    <p>
      <b>Explain the story links</b><br />
      The links to your story are like shared passwords to read or add to your story.
      Your story's read-only link allows anyone with the link to read the story, but not add pages.
      Your story's add-able link allows anyone with the link to read and add pages to the story.
      <br /><br />If you lose your story links ask someone you shared them with to send them back
      to you. We don't record your email so there is no way for us to recover the link.
    </p>

    <p>
      <b>I have another question</b><br />
      Email me at <a href="mailto:dan@addtothestory.com?subject=Question about AddToTheStory.com" class="caption text-uppercase grey--text">
        dan@addtothestory.com
      </a>.

    </p>
    <br />
  </v-container>
</template>

<script>
export default {
  name: 'HowItWorks',

  data: () => ({

  }),
  mounted () {

  }
}
</script>
